export const TABLE_COMMENT_DATA_TYPES = [
    'evidenceTable',
    'activityTable',
    'valueMessageTable',
    'strategicImperativeTable',
] as const

export const COMMENT_DATA_TYPES = [
    'evidence',
    'tppCell',
    'activity',
    'valueMessage',
    'strategicImperative',
    'valueNarrative',
    ...TABLE_COMMENT_DATA_TYPES,
] as const

export type CommentDataType = (typeof COMMENT_DATA_TYPES)[number]

export type CommentsProps = {
    dataId: string
    dataType: CommentDataType
    minimized?: boolean
    onCommentPosted?: () => void
    onCommentRemoved?: () => void
}

export type Comment = {
    _id: string
    text: string
    action?: string | null
    user: {
        _id: string
        name: string
    }
    createdAt: string
    isResolved: boolean
}
